export const es = {
    title: `Cambiar contraseña`,
    description: `Actualiza la contraseña de tu cuenta`,
    passwordChanged: `¡Contraseña cambiada con éxito!`,
    changePasswordButton: `Cambiar contraseña`,
    changingPassword: `Cambiando contraseña...`,
    sessionExpired: `Tu sesión ha expirado. Por favor inicia sesión nuevamente.`,
    failure: `El cambio de contraseña falló`,
};
//# sourceMappingURL=es.js.map